import Vue from 'vue'
// initial state
const state = {
  appointmentAddress: null,
  instance: {},
  instanceID: null,
  persons: {},
}

// getters
const getters = {}

// actions
const actions = {
}

// mutations
const mutations = {
  setProp (state, obj) {
    state[obj.prop] = obj.val
  },
  setInstance (state, instance) {
    state.instance = instance
  },
  setInstanceID (state, instanceID) {
    if (state.instanceID !== instanceID) {
      Vue.set(state, 'instanceID', instanceID)
    }
  },
  setPerson (state, person) {
    Vue.set(state.persons, person.ID, { instanceID: person.instanceID, ...person.data })
  },
  resetPersons (state) {
    state.persons = {}
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
